export default __webpack_public_path__ + "static/media/0-100.5acea489.jpg";